import { Validators } from '@angular/forms'

import { QuestionBase, QuestionOptions } from './base.question.class'

interface SliderQuestionOptions extends QuestionOptions<string> {
  type?: string
}

export class SliderQuestion extends QuestionBase<string> {
  controlType = 'slider'
  type = 'number'

  constructor(options: SliderQuestionOptions = { }) {
    super(options)

    if (this.options['minLength']) {
      this.validators.push(Validators.minLength(this.options['minLength']))
    }
    if (this.options['maxLength']) {
      this.validators.push(Validators.maxLength(this.options['maxLength']))
    }
  }
}
